export default __webpack_public_path__ + "static/media/piano.a43a3d86.svg";